"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.properCase = properCase;

var _lodash = require("lodash");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function splitWords(text, separator, ignoreWords) {
  var formattedIgnoreWords = ignoreWords.map(function (ignoreWord) {
    return (0, _lodash.toLower)(ignoreWord);
  });
  return text.split(separator).map(function (word) {
    var wordIndex = formattedIgnoreWords.indexOf((0, _lodash.toLower)(word));
    return wordIndex > -1 ? ignoreWords[wordIndex] : (0, _lodash.toUpper)(word.charAt(0)) + word.slice(1);
  }).join(separator);
}

function properCase(text) {
  var ignoreWords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var allIgnoreWords = ['LLC', 'LLC.', 'LP', 'I', 'II', 'III', 'IV', 'V'].concat(_toConsumableArray(ignoreWords));

  if (text === null) {
    return '';
  } else if (!text.match(/[\s-"]/)) {
    return (0, _lodash.startCase)((0, _lodash.lowerCase)(text));
  } else if (!text.match(/[-"']/)) {
    return splitWords((0, _lodash.toLower)(text), ' ', allIgnoreWords);
  } else {
    var spaceSplit = splitWords((0, _lodash.toLower)(text), ' ', allIgnoreWords);
    var dashSplit = splitWords(spaceSplit, '-', allIgnoreWords);
    var doubleQuoteSplit = splitWords(dashSplit, '"', allIgnoreWords);
    var singleQuoteSplit = splitWords(doubleQuoteSplit, "'", allIgnoreWords); // eslint-disable-line

    return singleQuoteSplit;
  }
}